import React, { useState } from 'react'; 
import Popup from '../components/CusPopup';
import { Checkbox } from '@progress/kendo-react-inputs';
import eData from '../hybriddata/popupdata.json';
import { Button } from '@progress/kendo-react-buttons';
import myinfoimg from '../styles/images/myinfo-logo.png';
import CusParagraph from '../components/CusParagraph';
import { FcCollapse, FcExpand } from 'react-icons/fc';

const SingpassDeclarePopup = (props) => {
    const {popupValue,setPopupValue} =props;
    const [isChecked, setIsChecked] = useState(false);
    const [showMyinfoDetails, setshowMyinfoDetails] = useState(false);

    const handleChkChange = (e) => {
        setIsChecked(e.value);
    }

    return(
        <Popup className="popUpBox" trigger={popupValue} setTrigger={setPopupValue}>
        <div style={{ textAlign: "left" }}>
          <div className="bgBlackYellowBorder fbaPSize rdBoxTop" >
            <div className="row">
              <div className="col-11">
                <div className="dcPgmh">
                  {eData.singPassPopup.header}
                </div>
              </div>
            </div>
          </div>
          <div className="bgGrey fbaPSize" style={{ paddingTop: '5px', paddingBottom: '5px' }}>
            <div className="row">
              <div className="dcPgm col-8"><b>Declaration</b></div>
              <div className="col-3" style={{ textAlign: "right" }} onClick={() => setshowMyinfoDetails(!showMyinfoDetails)} >
                {
                  showMyinfoDetails ? <div><FcCollapse /></div> : <div className=""><FcExpand /></div>
                }
              </div>
            </div>
            {showMyinfoDetails ?
              <div className="row">
                <div className="col-10 dcPgm">
                  {eData.singPassPopup.data.map((item, idx) => (
                    <CusParagraph key={idx} lblname={item.lblname} />
                  ))}
                </div>
              </div> : null
            }
          </div>
          <p style={{ marginTop: "1rem", fontWeight: "700", textAlign: "center" }}>
            {'Retrieve Myinfo with'}  <img src={myinfoimg} width="90px" />
          </p>

          <div className="fbaPSize" style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap' }}>
            <Checkbox defaultChecked={isChecked} style={{ fontWeight: "500" }} 
                label={eData.singPassPopup.cbdata} onChange={handleChkChange} />
          </div>
          <div style={{ marginTop: "1rem", textAlign: "left", display: 'flex', flexWrap: 'wrap', color: '#585858' }}>
            <ol style={{ listStyle: "disc", marginBottom: "0", fontSize: "x-small" }}> 
                {eData.singPassPopup.declareList.map((item, idx) => (
                <li key={idx}>
                {item.lblname}
                </li>
                ))}
            </ol>
        </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6" style={{ textAlign: "left" }}>
            <Button look="outline" className="btSize1 sccbTxt2"
              onClick={() => setPopupValue(false)}>{eData.singPassPopup.btCancel}</Button>
          </div>
          <div className="col-6" style={{ textAlign: "right" }}>
            <Button primary={true} className="btSize1 sccbTxt2 btRht greenbt"
              disabled={!isChecked}
              onClick={props.onClickProceed}>{eData.singPassPopup.btProceed}</Button>
          </div>
        </div>
        <br/>
      </Popup>
    )
}

export default SingpassDeclarePopup